import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { utils, write } from "xlsx";
import { Dialog } from "primereact/dialog";

import Loading from "../../../common/Loading";
import { Button, CalendarField } from "../../../helpers";


import { raiseToast } from "../../../services/redux/reducers/toast/toast";
import { fetchApprovalSecondary, fetchApprovals } from "../../../services/redux/reducers/commonThunk";

import { getVendorPaymentTracker } from "../../../services/api/vendorPayment";

import { getApproverDetails, getDateString, getFullName, getSellerPOApprovals } from "../../../utils";


const DownlaodPaymentTrackerModal = (props) => {
    const { visiblePaymentTrackerModal, setVisiblePaymentTrackerModal } = props

    const [isLoading, setIsLoading] = useState(false)

    const [toDate, setToDate] = useState(null)
    const [fromDate, setFromDate] = useState(null)

    const userDetails = useSelector(state => state.userDetails)
    const approvals = useSelector(state => state.common.approvals)
    const approvalSecondary = useSelector((state) => state.common.approvalSecondary)

    const pmCompanyUsers = userDetails.PMCompanyDetails.companyUsers ? userDetails.PMCompanyDetails.companyUsers : []
    const pmCompanyRoles = userDetails.PMCompanyDetails.companyRoles ? userDetails.PMCompanyDetails.companyRoles : []
    const pmBranches = userDetails.PMCompanyDetails.companyBranches ? userDetails.PMCompanyDetails.companyBranches : []

    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(fetchApprovals())
        dispatch(fetchApprovalSecondary())
    }, [])

    const handleOnDownload = async () => {
        if (!fromDate){
            return dispatch(raiseToast({ severity: 'error', detail: 'Please enter from date.'}))
        }

        if (!toDate){
            return dispatch(raiseToast({ severity: 'error', detail: 'Please enter to date.'}))
        }

        if (window.confirm("Do you want to download the payment tracker for the selected dates?")){
            setIsLoading(true)
            const paymentTrackerRes = await getVendorPaymentTracker({fromDate: fromDate, toDate: toDate})

            if(paymentTrackerRes.failure){
                setIsLoading(false)
                return dispatch(raiseToast({severity:'error', detail: paymentTrackerRes.data.error}))
            }

            downloadVPDataForPaymentTracker(paymentTrackerRes.data.vendorPayments, paymentTrackerRes.data.PIPunchBookingLogs, "XLSX")
            setFromDate(null)
            setToDate(null)
            setVisiblePaymentTrackerModal(false)
            setIsLoading(false)
        }
    }

    const downloadVPDataForPaymentTracker = async (vendorPayments, PIPunchBookingLogs, dataFormat) => {
        let paymentTrackerData = []
        vendorPayments.map((eachVendorPayment, index) => {

            let relatedPIPunchBookingLog = null

            if (eachVendorPayment.sellerPIPunchId){
                relatedPIPunchBookingLog = PIPunchBookingLogs.find(eachPIPunchBookingLog => eachPIPunchBookingLog.docNo === eachVendorPayment.sellerPIPunchDocNo)
            }

            let materialDetails = eachVendorPayment.sellerPOItemsWithMaterialDetails

            let productNamesArr = []

            materialDetails.map(eachMaterial => {
                productNamesArr.push(eachMaterial.productName)
            })

            let productNamesStr = ''
            productNamesStr = productNamesArr.join(", ")

            let paymentPeriod = ["PDC on Delivery", "payCredit", "Credit"].includes(eachVendorPayment.paymentTerm) ? eachVendorPayment.creditPeriod.toString() + ' Days'  : ""

            let sellerPOAmountApprovalTypeId = eachVendorPayment.expenseCategoryId ? 21 : 17
            let sellerPOApprovals = approvals.filter(eachApproval => eachApproval.approvalTypeId === sellerPOAmountApprovalTypeId)

            let updatedRequiredApprovals = getSellerPOApprovals({
                POApprovals: sellerPOApprovals,
                sellerPO: {...eachVendorPayment}, 
                sellerPIPunch: []
            })

            const relatedApproval = approvals.find(eachApproval => eachApproval.approvalId === updatedRequiredApprovals[0].approvalId)

            const primaryApprover = getApproverDetails(relatedApproval, eachVendorPayment.pmBranchId, eachVendorPayment.createdBy, pmCompanyUsers, pmCompanyRoles, pmBranches, approvalSecondary)
            const primaryApproverName = getFullName(primaryApprover[0]?.firstName, primaryApprover[0]?.lastName)

            let approvalAuthorityStr = relatedApproval.approvalTitle.toString() + " " + primaryApproverName

            const newVendorPaymentObj = {
                "Sr No.": index + 1,
                "Vendor Name": eachVendorPayment.sellerCompanyName,
                "Type Of Vendor": eachVendorPayment.tdsSectionId && eachVendorPayment.tdsSectionId !== 1 ? "Services" : "Goods",
                "PO No": eachVendorPayment.sellerPODocNo,
                "Buyer PO No": eachVendorPayment.buyerPODocNo,
                "Client PO No": eachVendorPayment.clientPONum,
                "Payment Purpose": eachVendorPayment.expenseCategoryId ? "Expense" : "Trading",
                "Description of Products": productNamesStr,
                "Payment Terms": eachVendorPayment.paymentTerm,
                "Payment Period": paymentPeriod,
                "Approval Authority": approvalAuthorityStr,
                "Seller PO Amount": eachVendorPayment.totalItemAmountBeforeTax,
                "Taxable Amount": eachVendorPayment.totalPOTax,
                "PPN Amount": '',
                "Payment Amount": eachVendorPayment.totalItemAmountWithTax,
                "Vendor Balance": '',
                "Payment Req Date": getDateString(eachVendorPayment.paymentReqDate),
                "Payment Date": eachVendorPayment.paymentDate,
                "Seller Invoice Booked": relatedPIPunchBookingLog ? relatedPIPunchBookingLog.bookedStatus : "No",
                "Seller Invoice No": eachVendorPayment.sellerPINumber,
                "Invoice Date": eachVendorPayment.sellerPIDate,
                "GRN Date": eachVendorPayment.GRNDate ? eachVendorPayment.GRNDate : null,
                "Invoice Qty": '',
                "Invoice Amount": eachVendorPayment.sellerPICalculatedTotalAmount,
                "Invoiced To Client": '',
                "Customer Name": eachVendorPayment.buyerCompanyName,
                "Customer invoice No.": eachVendorPayment.buyerInvoiceDocNo,
                "Customer invoice Qty": '',
                "Basic Amount": eachVendorPayment.buyerBasicAmount,
                "PPN": '',
                "Sale amount": '',
                "Bal Inventory": '',
                "Inventory Amount": ''
            }

            paymentTrackerData.push(newVendorPaymentObj)
        })

        if(dataFormat === "XLSX"){
            const ws = utils.json_to_sheet(paymentTrackerData)

                const range = utils.decode_range(ws['!ref']);
                for (let R = range.s.r; R <= range.e.r; ++R) {
                    for (let C = range.s.c; C <= range.e.c; ++C) {
                        const cellAddress = utils.encode_cell({ r: R, c: C });
                        if (ws[cellAddress] && ws[cellAddress].t === 's' && ws[cellAddress].v.charAt(0) === "'") {
                            ws[cellAddress].v = ws[cellAddress].v.substring(1);
                        }
                    }
                }

                const wb = utils.book_new()
                utils.book_append_sheet(wb, ws, 'Sheet1')
                const blob = new Blob([write(wb, { bookType: 'xlsx', type: 'array' })])
                const url = URL.createObjectURL(blob)
                const a = document.createElement('a')
                a.href = url
                a.download = 'Payment-daily-tracker.xlsx'
                a.click()
                URL.revokeObjectURL(url)
        }
    }

    return (
        <Dialog header="Payment Tracker" visible={visiblePaymentTrackerModal} style={{ width: '35vw', height: '30vh' }} onHide={() => { setVisiblePaymentTrackerModal(false); setFromDate(null); setToDate(null) }}>
            <div>
                <div className="grid">
                    <div className="flex flex-column col-12 mb-2 md:col-6 lg:col-16 lg:mb-0">
                        <CalendarField name="fromDate" maxDate={new Date()} labelText="From Date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
                    </div>
                    <div className="flex flex-column col-12 mb-2 md:col-6 lg:col-16 lg:mb-0">
                        <CalendarField name="toDate" maxDate={new Date()} labelText="To Date" value={toDate} onChange={(e) => setToDate(e.target.value)} />
                    </div>
                </div>
                <div className="flex justify-content-end mt-4">
                    <Button className="h-2rem  p-2" label="Download" onClick={() => handleOnDownload()} />
                </div>
            </div>
            <Loading visible={isLoading}/>
        </Dialog>
    )
}

export default DownlaodPaymentTrackerModal